import { render, staticRenderFns } from "./Coffee.vue?vue&type=template&id=9880bd78&scoped=true&"
import script from "./Coffee.vue?vue&type=script&lang=js&"
export * from "./Coffee.vue?vue&type=script&lang=js&"
import style0 from "./Coffee.vue?vue&type=style&index=0&id=9880bd78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9880bd78",
  null
  
)

export default component.exports